import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';
import { ButtonSizes, IconTypes } from '@shared/v2/models';
import { SdvorIconComponent } from '../icon';

/**
 * `NavigationButtonComponent` отображает кнопку навигации
 *
 * ```ts
 * import { NavigationButtonComponent } from '@sdvor/shared/ui/v2';
 * ```
 */
@Component({
  selector: 'button[sdNavButton]',
  imports: [SdvorIconComponent],
  templateUrl: './navigation-button.component.html',
  styleUrls: ['./navigation-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavigationButtonComponent {
  /** Размер кнопки */
  @Input() size: ButtonSizes;
  /** Иконка */
  @Input() icon: IconTypes;

  /** @ignore */
  @HostBinding('class')
  get classNames(): string[] {
    return ['nav-button'];
  }
}
